/* Solarii collection filter, desktop (sections/solarii-ring-filter.liquid). 2026-10-25 v3
   The filter bar scrolls away with the page like normal content. Once it is gone, a floating "Filter & Sort"
   button appears at the bottom of the screen and opens every filter in a side panel. Nothing is pinned to the
   top, so the store header can hide and come back without ever touching the filters. */
(function () {
  'use strict';
  var KEYS = ['filter.p.m.custom.stone_shape', 'filter.p.m.custom.plating_color', 'filter.p.m.custom.carat', 'filter.p.m.custom.stone_color'];
  var GRID = '#CollectionProductGrid, .collection__products, .product-grid, .collection-product-grid';
  // Parts of the store header that can be on screen: the announcement bar and the menu (which slides away)
  var HEADER_PARTS = '.header-sections .page-announcement, .header-sections .theme__header, .header-sections [data-mg-header-nav], .header-sections [data-header-height]';

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // Lowest edge of the store header currently on screen (0 when it has scrolled away)
  function headerBottom() {
    var b = 0;
    document.querySelectorAll(HEADER_PARTS).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.bottom > b) b = r.bottom;
    });
    return b;
  }
  // Full height of the header when it stays fixed on screen, to scroll the first products clear of it
  function headerSpace() {
    var g = document.querySelector('.header-sections');
    if (!g) return 0;
    var p = getComputedStyle(g).position;
    return p === 'fixed' || p === 'sticky' ? g.getBoundingClientRect().height : 0;
  }

  function init(root) {
    if (root.dataset.srdReady) return;
    root.dataset.srdReady = '1';

    var GTE = root.dataset.priceGte || 'filter.v.price.gte';
    var LTE = root.dataset.priceLte || 'filter.v.price.lte';
    var multi = root.dataset.multi === 'true';
    var state = {}, price = '', sort = '';

    var sp = new URLSearchParams(location.search);
    KEYS.forEach(function (k) { state[k] = sp.getAll(k); });
    if (sp.get(GTE) !== null || sp.get(LTE) !== null) price = (sp.get(GTE) || '0') + '-' + (sp.get(LTE) || '');
    sort = sp.get('sort_by') || '';

    // The floating button and the side panel move under <body>, so no page wrapper can trap them below the
    // header. Copies left over from an earlier render of this section (theme editor) are removed first.
    var floatEl = root.querySelector('[data-srd-float]');
    var drawer = root.querySelector('[data-srd-drawer]');
    document.querySelectorAll('[data-srd-owner="' + root.id + '"]').forEach(function (el) { el.parentNode.removeChild(el); });
    [floatEl, drawer].forEach(function (el) {
      if (!el) return;
      el.setAttribute('data-srd-owner', root.id);
      document.body.appendChild(el);
    });
    var scopes = [root, floatEl, drawer].filter(Boolean);
    function each(sel, fn) { scopes.forEach(function (s) { s.querySelectorAll(sel).forEach(fn); }); }

    var sortSel = root.querySelector('[data-srd-sort]');
    if (sortSel) {
      sortSel.value = sort;
      if (sortSel.value !== sort) sortSel.value = '';
      sortSel.addEventListener('change', function () { sort = sortSel.value; apply(true); });
    }

    // Side panel content: the same options as the bar (shape row, every dropdown) plus sorting
    function buildDrawer() {
      var body = drawer.querySelector('[data-srd-drawer-body]');
      if (!body) return;
      body.innerHTML = '';
      function group(title, node) {
        var g = document.createElement('section');
        g.className = 'srd-group';
        var h = document.createElement('p');
        h.className = 'srd-group-title';
        h.textContent = title;
        g.appendChild(h);
        g.appendChild(node);
        body.appendChild(g);
      }
      var shapes = root.querySelector('.srd-shape-list');
      if (shapes) {
        var sl = root.querySelector('.srd-shapes .srd-row-label');
        group(sl ? sl.textContent : 'Stone Shape', shapes.cloneNode(true));
      }
      root.querySelectorAll('.srd-dd').forEach(function (dd) {
        var t = dd.querySelector('.srd-panel-title'), o = dd.querySelector('.srd-opts');
        if (o) group(t ? t.textContent : '', o.cloneNode(true));
      });
      if (sortSel) {
        var list = document.createElement('div');
        list.className = 'srd-opts srd-opts--sort';
        Array.prototype.forEach.call(sortSel.options, function (op) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'srd-opt';
          b.setAttribute('data-srd-sortval', op.value);
          b.textContent = op.textContent;
          list.appendChild(b);
        });
        var st = root.querySelector('.srd-sort > span');
        group(st ? st.textContent : 'Sort', list);
      }
    }
    if (drawer) buildDrawer();

    function on(btn) {
      var k = btn.dataset.srdKey, v = btn.dataset.srdVal;
      return k === 'price' ? price === v : (state[k] || []).indexOf(v) > -1;
    }
    function labelFor(k, v) {
      var b = root.querySelector('[data-srd-key="' + k + '"][data-srd-val="' + (window.CSS && CSS.escape ? CSS.escape(v) : v) + '"]');
      return b ? (b.dataset.label || v) : v;
    }

    function render() {
      each('[data-srd-key]', function (b) { b.setAttribute('aria-pressed', String(on(b))); });
      each('[data-srd-sortval]', function (b) { b.setAttribute('aria-pressed', String(b.dataset.srdSortval === sort)); });
      root.querySelectorAll('[data-count-for]').forEach(function (p) {
        var k = p.dataset.countFor, n = k === 'price' ? (price ? 1 : 0) : (state[k] || []).length;
        p.classList.toggle('has', n > 0);
        p.querySelector('.srd-n').textContent = n || '';
      });
      var total = (price ? 1 : 0);
      KEYS.forEach(function (k) { total += state[k].length; });
      each('[data-srd-total]', function (el) { el.textContent = total || ''; el.classList.toggle('has', total > 0); });
      var box = root.querySelector('[data-srd-chips]');
      if (!box) return;
      var html = '';
      KEYS.forEach(function (k) {
        state[k].forEach(function (v) {
          html += '<button type="button" class="srd-chip" data-rm="' + k + '" data-v="' + encodeURIComponent(v) + '">' + esc(labelFor(k, v)) + '<i aria-hidden="true">×</i></button>';
        });
      });
      if (price) html += '<button type="button" class="srd-chip" data-rm="price" data-v="">' + esc(labelFor('price', price)) + '<i aria-hidden="true">×</i></button>';
      if (html) html += '<button type="button" class="srd-link" data-clear="all">' + esc(box.dataset.clearAll || 'Clear all') + '</button>';
      box.innerHTML = html;
      box.hidden = !html;
    }

    function buildUrl() {
      var p = new URLSearchParams();
      KEYS.forEach(function (k) { state[k].forEach(function (v) { p.append(k, v); }); });
      if (price) {
        var a = price.split('-');
        if (parseFloat(a[0]) > 0) p.set(GTE, a[0]);
        if (a[1]) p.set(LTE, a[1]);
      }
      if (sort) p.set('sort_by', sort);
      var q = p.toString();
      return location.pathname + (q ? '?' + q : '');
    }

    var timer = null, controller = null, drawerOpen = false, changed = false, lastFocus = null;
    function apply(now) {
      if (drawerOpen) changed = true;
      render();
      clearTimeout(timer);
      timer = setTimeout(load, now ? 0 : 280);
    }
    function load() {
      var url = buildUrl();
      var grid = document.querySelector(GRID);
      var count = root.querySelector('[data-srd-count-wrap]');
      var showBtn = drawer ? drawer.querySelector('[data-srd-show]') : null;
      history.replaceState(history.state, '', url);
      if (!grid) { location.href = url; return; }
      if (controller) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      grid.style.transition = 'opacity .2s';
      grid.style.opacity = '.4';
      if (count) count.classList.add('is-loading');
      if (showBtn) showBtn.classList.add('is-loading');
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: controller ? controller.signal : undefined })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector(GRID);
          if (fresh) grid.innerHTML = fresh.innerHTML;
          var n = doc.querySelector('#' + root.id + ' [data-srd-count], #' + root.id + ' [data-srd-count-drawer]');
          if (n) each('[data-srd-count], [data-srd-count-drawer]', function (el) { el.textContent = n.textContent; });
          grid.style.opacity = '1';
          if (count) count.classList.remove('is-loading');
          if (showBtn) showBtn.classList.remove('is-loading');
          document.dispatchEvent(new CustomEvent('solarii:filters-updated', { detail: { url: url } }));
          controller = null;
          queue();
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          grid.style.opacity = '1';
          if (count) count.classList.remove('is-loading');
          if (showBtn) showBtn.classList.remove('is-loading');
          controller = null;
        });
    }

    function closeAll(except) {
      root.querySelectorAll('.srd-dd.is-open').forEach(function (dd) {
        if (dd === except) return;
        dd.classList.remove('is-open');
        dd.querySelector('.srd-pill').setAttribute('aria-expanded', 'false');
      });
    }

    function openDrawer() {
      if (!drawer || drawerOpen) return;
      closeAll();
      drawerOpen = true;
      changed = false;
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      update();
      var x = drawer.querySelector('.srd-drawer-x');
      if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 50);
    }
    function closeDrawer() {
      if (!drawerOpen) return;
      drawerOpen = false;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      // Filters changed in the panel: bring the first matching products into view
      var grid = changed ? document.querySelector(GRID) : null;
      if (grid) {
        var y = grid.getBoundingClientRect().top + window.pageYOffset - headerSpace() - 16;
        if (window.pageYOffset > y + 4) window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }
      changed = false;
      update();
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    }

    function onClick(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-srd-open]')) { openDrawer(); return; }
      var pill = root.contains(t) ? t.closest('.srd-pill') : null;
      if (pill) {
        var dd = pill.parentElement, open = !dd.classList.contains('is-open');
        closeAll(dd);
        dd.classList.toggle('is-open', open);
        pill.setAttribute('aria-expanded', String(open));
        if (open) {
          var panel = dd.querySelector('.srd-panel');
          panel.classList.remove('to-right');
          if (panel.getBoundingClientRect().right > window.innerWidth - 16) panel.classList.add('to-right');
        }
        return;
      }
      var opt = t.closest('[data-srd-key]');
      if (opt) {
        var k = opt.dataset.srdKey, v = opt.dataset.srdVal;
        if (k === 'price') { price = price === v ? '' : v; }
        else {
          var list = state[k], i = list.indexOf(v);
          if (i > -1) list.splice(i, 1);
          else if (multi) list.push(v);
          else state[k] = [v];
        }
        apply(false);
        return;
      }
      var so = t.closest('[data-srd-sortval]');
      if (so) {
        sort = so.dataset.srdSortval;
        if (sortSel) sortSel.value = sort;
        apply(true);
        return;
      }
      var rm = t.closest('[data-rm]');
      if (rm) {
        if (rm.dataset.rm === 'price') price = '';
        else { var val = decodeURIComponent(rm.dataset.v); state[rm.dataset.rm] = state[rm.dataset.rm].filter(function (x) { return x !== val; }); }
        apply(true);
        return;
      }
      var clr = t.closest('[data-clear]');
      if (clr) {
        var g = clr.dataset.clear;
        if (g === 'all' || g === 'price') price = '';
        KEYS.forEach(function (k) { if (g === 'all' || g === k) state[k] = []; });
        apply(true);
        return;
      }
      if (t.closest('[data-srd-close]')) { closeDrawer(); return; }
      if (t.closest('.srd-done')) closeAll();
    }
    scopes.forEach(function (s) { s.addEventListener('click', onClick); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawerOpen) closeDrawer();
      else closeAll();
    });

    if (drawer) {
      // While the panel is open the page behind it stays put: wheel and touch scrolling only move the option list
      var dBody = drawer.querySelector('[data-srd-drawer-body]');
      drawer.addEventListener('wheel', function (e) {
        if (!dBody || !dBody.contains(e.target)) { e.preventDefault(); return; }
        var up = e.deltaY < 0;
        if ((up && dBody.scrollTop <= 0) || (!up && dBody.scrollTop + dBody.clientHeight >= dBody.scrollHeight - 1)) e.preventDefault();
      }, { passive: false });
      drawer.addEventListener('touchmove', function (e) { if (!dBody || !dBody.contains(e.target)) e.preventDefault(); }, { passive: false });
      // Keep keyboard focus inside the open panel
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !drawerOpen) return;
        var f = Array.prototype.filter.call(drawer.querySelectorAll('button, [href], select, input, [tabindex]:not([tabindex="-1"])'), function (el) {
          return !el.disabled && el.getClientRects().length > 0;
        });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    // Floating button: shown once the bar is out of sight, while the products are still on screen
    var bar = root.querySelector('.srd-bar');
    function update() {
      if (!floatEl || !root.isConnected) return;
      var show = false;
      if (!drawerOpen && window.innerWidth >= 768 && bar) {
        var grid = document.querySelector(GRID);
        var gone = bar.getBoundingClientRect().bottom < headerBottom() + 4;
        var inGrid = grid ? grid.getBoundingClientRect().bottom > window.innerHeight * 0.4 : true;
        show = gone && inGrid;
      }
      if (show !== floatEl.classList.contains('is-shown')) {
        floatEl.classList.toggle('is-shown', show);
        if (show) closeAll();
      }
    }
    var frame = 0;
    function queue() { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);

    render();
    update();
  }

  function start() { document.querySelectorAll('[data-srd]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (!id) return;
    document.querySelectorAll('[data-srd-owner="srd-' + id + '"]').forEach(function (el) { el.parentNode.removeChild(el); });
  });
})();
